import { downloadImageAsBase64 } from './downloadImageAsBase64';

export const replaceWithBase64 = (
  images: NodeListOf<HTMLImageElement>
): Promise<void> => {
  return Promise.all(
    Array.from(images).map(image => {
      return new Promise<void>((resolve, reject) => {
        const src = image.src;

        downloadImageAsBase64(src)
          .then(imageAsBase64 => {
            image.src = imageAsBase64;
            resolve();
          })
          .catch(reject);
      });
    })
  ).then(() => {});
};
